import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { SortingDirection } from '../../types/sorting'
import { getNextSortingDirection, isAsc, isDesc } from '../../utils/sorting'

export const SortButton = ({
  sort,
  onSort,
}: {
  sort: SortingDirection
  onSort: (sortDirection: SortingDirection) => void
}) => {
  const { t } = useTranslation()
  const getIcon = () => {
    if (isAsc(sort)) return faSortUp
    if (isDesc(sort)) return faSortDown
    return faSort
  }

  return (
    <Button
      label="sort"
      title={t('Sort')}
      size="xs"
      type="blank-default"
      hideLabel
      icon={<FontAwesomeIcon icon={getIcon()} />}
      onClick={() => onSort(getNextSortingDirection(sort))}
    />
  )
}
